export interface IDashboardState {
  readonly teamSelection?: {
    id: string;
    name: string;
  };
  hideUpcomingMatches: boolean;
}

export type IDashboardSelector = IDashboardState

export enum DashboardActionTypes {
  UPDATE_DASHBOARD_CONFIG = 'redux-app/payment-event-dashboard/UPDATE_DASHBOARD_CONFIG',
}

export default null;
